import { WidgetComponent as WidgetComponentV1 } from '../v1/WidgetComponent';
import { WidgetComponent as WidgetComponentV2 } from '../v2/WidgetComponent';
import { BadVersion } from '../../components/BadVersion';
import { VERSIONS } from '../../../../constants';

const widgetsByVersionsMap = {
    [VERSIONS.V1]: WidgetComponentV1,
    [VERSIONS.V2]: WidgetComponentV2,
};

export const getWidgetByVersion = (version: string = VERSIONS.FALLBACK) => widgetsByVersionsMap[version] || BadVersion;
